import React from 'react';
import {CheckedProspectPoolsContext} from '../CheckedProspectPoolContext';
import {ProspectPool} from 'api';

interface Props {
  prospectPool: ProspectPool;
}

export default ({prospectPool}: Props) => {
  const {checkedProspectPoolIds, setCheckedProspectPoolIds} = React.useContext(
    CheckedProspectPoolsContext,
  );

  const onCheck = () => {
    const ids = !checkedProspectPoolIds.includes(prospectPool.id)
      ? [...checkedProspectPoolIds, prospectPool.id]
      : checkedProspectPoolIds?.filter(
          (checkedProspectPoolId) => checkedProspectPoolId !== prospectPool.id,
        );
    setCheckedProspectPoolIds(ids);
  };

  return (
    <div className="flex items-center justify-center ml-5">
      <input
        type="checkbox"
        checked={checkedProspectPoolIds?.includes(prospectPool.id)}
        onChange={onCheck}
        className="form-checkbox"
      />
    </div>
  );
};
